import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { tipoFecha, fechaRegistro, complementoFecha, poliza as textoAyudaPoliza, consecutivo } from "../../config_general/modelo/TextosAyuda";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import { TipoFechaMoraNota } from "../modelo/TipoFechaMoraNota";
import { ComplementosFecha } from "../../config_general/modelo/ComplementosFecha";
import { DotLoader } from "react-spinners";
import { TipoReportes } from "../../descarga_reporte/modelo/TiposReporte";
import ModalAyudaVentana from "../../config_general/componentes/ModalAyudaVentana";
import { tituloVentanaCargaMora } from "../../config_general/modelo/TextoVentanaAyuda";
import { FiltroConsultarEnvioMora } from "../modelo/EnviosMoraModelo";
import TablaMoraNotas from "./TablaMoraNotas";
import {consultarEnviosMora, descargarXlsEnviosMora} from "../modulos/consultaEnvioMoraActions";
import ModalXLSDatosGlosas from "../../inconsistencias/componentes/ModalXLSDatosGlosas";
import MensajeConAccion from "../../../general/componentes/MensajeConAccion";

class FiltroConsultaEnvioMora extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.generarXLS = this.generarXLS.bind(this);

        this.state = {
            ventanaAyuda: false,
            showModalXLS: false,
            maxRegistrosXLS: 10000
        };
    }

    render() {
        const { totalMoraNotasConsulta } = this.props;
        return (
            <div>
                <Row>
                    {this.crearVentanaAyuda()}
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Envio Manual Mora
                                    <button type="button" className="btns btns-glyphicon" onClick={this.actualizarModalAyuda}
                                        disabled={this.state.ventanaAyuda}>
                                        <span className="icons-table">
                                            <Glyphicon style={{ left: `10px` }} glyph="question-sign" />
                                        </span>
                                    </button>
                                </h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta Envio Manual Mora</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="numeroPoliza">Póliza</label>
                                                <TextoAyuda texto={textoAyudaPoliza} />
                                                <NumericInput name="numeroPoliza" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="consecutivo">Consecutivo Proceso</label>
                                                <TextoAyuda texto={consecutivo} />
                                                <NumericInput name="consecutivo" />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoFecha">Tipo Fecha</label>
                                                <TextoAyuda texto={tipoFecha} />
                                                <TextoInputSelector name="tipoFecha" maestro={this.listaTipoFechaMoraNota()} />
                                                {errors.tipoFecha &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoFecha}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Registro</label>
                                                <TextoAyuda texto={fechaRegistro} />
                                                <DatePickerSura name={"fecha"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="complementoFecha">Complemento Fecha</label>
                                                <TextoAyuda texto={complementoFecha} />
                                                <TextoInputSelector name="complementoFecha" maestro={this.listarSignoFechas()} />
                                                {errors.complementoFecha &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.complementoFecha}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                            <Col sm={2}>
                                                    {
                                                        (totalMoraNotasConsulta > 0) &&
                                                        <a className="btns btn-success" onClick={this.obtenerXLS}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                    {this.state.showModalXLS && this.mostrarModalXLS()}
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderEstadoDescargaXLS()}
                    {this.renderTablaConsultaEnvioMora()}
                </Row>
            </div>
        );
    }

    renderTablaConsultaEnvioMora() {
        const { moraNotas, estadoConsulta, paginas, tamanoPagina, paginaActual } = this.props;

        switch (estadoConsulta) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!moraNotas || !moraNotas.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado registros con los filtros seleccionados."} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaMoraNotas
                                moraNotas={moraNotas}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    renderEstadoDescargaXLS() {
        const { estadoDescarga } = this.props;
        switch (estadoDescarga) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={"Se ha presentado un error al generar el reporte, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                        <br />
                    </div>);
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <MensajeConAccion type={"success"} mensaje={"Se genero el reporte con exito"} />
                    </span>
                );
            default:
                return false;
        }
    }

    mostrarModalXLS() {
        const { totalMoraNotasConsulta, tamanoPagina } = this.props;
        const reportesXLS = Math.ceil(totalMoraNotasConsulta / this.state.maxRegistrosXLS);
        const totalPaginas = Math.ceil(totalMoraNotasConsulta / tamanoPagina);
        return (
            <ModalXLSDatosGlosas
                totalGlosasConsulta={totalMoraNotasConsulta}
                reportesXLS={reportesXLS}
                totalPaginas={totalPaginas}
                showModalXLS={this.state.showModalXLS}
                closeModalXLS={() => this.handleCloseModalXLS()}
                generarXLS={this.generarXLS}
                maxRegistrosXLS={this.state.maxRegistrosXLS}
                tamanoPaginaFiltro={tamanoPagina}
            />
        );
    }

    handleCloseModalXLS() {
        this.setState({ showModalXLS: false });
    }

    obtenerXLS = () => {
        const { totalRegistros } = this.props;
        if (totalRegistros < this.state.maxRegistrosXLS) {
            this.generarXLS(0);
        } else {
            this.setState({ showModalXLS: true });
        }
    };

    generarXLS(reporte: number) {
        const filtro: FiltroConsultarEnvioMora = {
            dniEmpleador: this.state.dniEmpleador,
            poliza: this.state.poliza,
            consecutivo: this.state.consecutivo,
            tipoFecha: this.state.tipoFecha,
            fecha: this.state.fecha,
            complementoFecha: this.state.complementoFecha,
            tamanoPagina: this.state.maxRegistrosXLS,
            paginaActual: reporte
        };

        this.props.dispatch(descargarXlsEnviosMora(filtro));
    }

    validate = (values: any) => {
        const errors = {
            tipoDocumento: undefined,
            documento: undefined,
            numeroPoliza: undefined,
            consecutivo: undefined,
            tipoFecha: undefined,
            fecha: undefined,
            complementoFecha: undefined,
            datosVacios: undefined
        };

        if (values.tipoDocumento && !values.documento) {
            errors.documento = " Se debe ingresar el numero de documento";
        }

        if (!values.tipoDocumento && values.documento) {
            errors.documento = " Se debe seleccionar el tipo de documento";
        }

        if (!values.tipoDocumento && !values.documento && !values.tipoFecha
            && !values.fecha && !values.complementoFecha
            && !values.consecutivo && !values.numeroPoliza) {
            errors.datosVacios = " Se debe ingresar un valor";
        }

        if (values.tipoFecha || values.fecha || values.complementoFecha) {
            errors.tipoFecha = values.tipoFecha ? undefined : "Por favor seleccione el tipo";
            errors.fecha = values.fecha ? undefined : "Por favor seleccione la fecha";
            errors.complementoFecha = values.complementoFecha ? undefined : "Por favor una de las opciones";
        }

        return errors;
    };

    onSubmit = (values: any) => {
        const dni = (values.tipoDocumento && values.documento) ? (values.tipoDocumento + values.documento) : undefined;
        const poliza = values.numeroPoliza ? values.numeroPoliza : undefined;
        const tipoFecha = values.tipoFecha ? values.tipoFecha.value : undefined;
        const fecha = values.fecha ? values.fecha.valueOf() : undefined;
        const complementoFecha = values.complementoFecha ? Number(values.complementoFecha.value) : undefined;
        const consecutivo = values.consecutivo ? values.consecutivo.valueOf() : undefined;

        const filtro: FiltroConsultarEnvioMora = {
            dniEmpleador: dni,
            poliza: poliza,
            consecutivo: consecutivo,
            tipoFecha: tipoFecha,
            fecha: fecha,
            complementoFecha: complementoFecha,
            tamanoPagina: this.props.tamanoPagina
        };

        this.setState({
            dniEmpleador: dni,
            poliza: poliza,
            consecutivo: consecutivo,
            tipoFecha: tipoFecha,
            fecha: fecha,
            complementoFecha: complementoFecha,
            filtro: filtro
        });

        this.props.dispatch(consultarEnviosMora(filtro));
    }

    filtros(): FiltroConsultarEnvioMora {
        return {
            dniEmpleador: this.state.dni,
            poliza: this.state.poliza,
            consecutivo: this.state.consecutivo,
            tipoFecha: this.state.tipoFecha,
            fecha: this.state.fecha,
            complementoFecha: this.state.complementoFecha
        };
    }

    listarSignoFechas = () => {
        return [].concat(
            ComplementosFecha.map(value => ({
                value: value.codigo,
                label: value.nombre
            })
            ));
    }

    listaTipoFechaMoraNota = () => {
        return [].concat(
            TipoFechaMoraNota.map(value => ({
                value: value.nombreEnvio,
                label: value.nombreProceso
            })
            ));
    }

    actualizarModalAyuda = () => {
        this.setState({ ventanaAyuda: !this.state.ventanaAyuda });
    }

    crearVentanaAyuda = () => {
        return (
            <ModalAyudaVentana
                titulo={tituloVentanaCargaMora}
                visible={this.state.ventanaAyuda}
                onCancelar={this.actualizarModalAyuda}
            >
                <p style={{ color: "#000000" }}>Por medio de esta ventana podrás consultar los envios a marcar o desmarcar de forma individual o masiva de periodos en mora de las empresas.
                    <br />
                    Para realizar la consulta se deben seleccionar los filtros por los cuales se desea consultar y luego dar click en el boton <strong>Consultar</strong>
                </p>
            </ModalAyudaVentana >
        );
    }

    descargarXLS = (tipo: TipoReportes) => {
        console.log(tipo);
    }

    consultaPaginada = (filtro: FiltroConsultarEnvioMora) => {
        this.props.dispatch(consultarEnviosMora(filtro));
    };
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoConsulta: R.pathOr(undefined, ["consulta_envio_mora", "estadoConsulta"])(store),
        estadoDescarga: R.pathOr(undefined, ["consulta_envio_mora", "estadoDescarga"])(store),
        mensajeConsulta: R.pathOr(undefined, ["consulta_envio_mora", "mensajeConsulta"])(store),
        moraNotas: R.pathOr([], ["consulta_envio_mora", "moraNotas"])(store),
        paginas: R.pathOr(undefined, ["consulta_envio_mora", "paginas"])(store),
        paginaActual: R.pathOr(undefined, ["consulta_envio_mora", "paginaActual"])(store),
        tamanoPagina: R.pathOr(undefined, ["consulta_envio_mora", "tamanoPagina"])(store),
        totalMoraNotasConsulta: R.pathOr(undefined, ["consulta_envio_mora", "totalMoraNotasConsulta"])(store),
    };
})(FiltroConsultaEnvioMora);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_envio_mora/componentes/FiltroConsultaEnvioMora.tsx